<div class="h-full flex flex-col overflow-visible">
    <div
        class="shrink-0 flex flex-row gap-x-4 items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 overflow-visible">

        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToCreators()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">My Creator Groups
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Add creators to groups for better organisation & sending off for review.</p>
            </div>
        </div>

        <button type="button" (click)="whatsNewService.open()"
            class="inline-flex shrink-0 items-center gap-x-1.5 secondary-button text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
                <path d="M9.9 2.1 8.5 6.4 4.2 7.8l4.3 1.4L9.9 13.5l1.4-4.3 4.3-1.4-4.3-1.4Z" />
                <path d="M18 14l-.7 2.2L15 17l2.3.8L18 20l.7-2.2L21 17l-2.3-.8Z" />
            </svg>
            What's new
        </button>
    </div>

    <!-- Groups -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden pt-2">
        <div class="w-full h-full grid grid-cols-3 gap-x-4">
            <article
                class="col-span-1 h-full flex flex-col gap-y-2 card-container-pale-no-padding divide-y divide-zinc-200 dark:divide-zinc-600 overflow-hidden">
                <!-- Header -->
                <div class="shrink-0 px-2 py-2 drawer-header-primary">
                    <div class="flex h-full items-center justify-between gap-x-3">
                        <div class="min-w-0 flex-1 px-2">
                            <p class="text-md font-semibold text-primary">
                                All Groups
                            </p>
                            <p class="text-sm text-secondary">
                                Private groups and groups shared with your team
                            </p>
                        </div>

                        <button (click)="showCreateGroupModal.set(true)" type="button"
                            class="inline-flex shrink-0 items-center gap-x-1.5 primary-button">
                            Add Group
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5" aria-hidden="true">
                                <path d="M12 5v14" />
                                <path d="M5 12h14" />
                            </svg>
                        </button>
                    </div>
                </div>
                <!-- Header - END -->
                <!-- Main Content -->
                @if (groupList().length) {
                <div class="flex-1 flex flex-col items-center overflow-hidden">
                    <ul role="list"
                        class="divide-y divide-gray-100 dark:divide-white/5 overflow-y-auto scrollbar-transparent w-full px-2">
                        <!-- @for (group of displayRecruitGroups(); track group.id) { -->
                        @for (group of groupList(); track group.id) {
                        <li (click)="selectGroup(group)"
                            class="flex justify-between items-center gap-x-6 py-2 px-2 rounded-md cursor-pointer hover:bg-primary/10 dark:hover:bg-primary/15"
                            [class]="selectedGroup()?.id === group.id ? 'bg-primary/10 dark:bg-primary/15' : ''">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="size-12 rounded-full flex items-center justify-center text-white"
                                    [class]="folderIconClass(group)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776" />
                                    </svg>
                                </div>

                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">{{ group.groupName }}
                                    </p>
                                    <p class="truncate text-xs/5 text-gray-500 dark:text-gray-400">
                                        {{ groupVisibleDescription(group) }}</p>
                                    <div class="mt-1 flex flex-wrap items-center gap-1">
                                        @if (isShoutGroup(group)) {
                                        <p
                                            class="m-0 inline-flex items-center rounded-full bg-teal-500/10 px-2 py-0.5 text-xs font-medium text-teal-700 dark:text-teal-400">
                                            Created by SHOUT</p>
                                        }
                                        <p class="m-0 inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                                            [class]="visibilityPillClass(group)">{{ visibilityLabel(group) }}</p>
                                        <p class="m-0 inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-secondary dark:bg-white/10">
                                            {{ creatorCountLabel(group) }}</p>
                                        @if (groupHasCreatorNotes(group)) {
                                        <p
                                            class="m-0 inline-flex items-center rounded-full bg-sky-100 px-2 py-0.5 text-xs font-medium text-sky-800 dark:bg-sky-900/30 dark:text-sky-200">
                                            Feedback</p>
                                        }
                                        @if (isGroupLocked(group)) {
                                        <p title="Synced with SHOUT AI — creators can be added but not removed"
                                            class="m-0 inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-secondary dark:bg-white/10">
                                            &#8635; Synced</p>
                                        }
                                        @for (brief of groupUsageBriefs(group); track brief.briefId) {
                                        <p
                                            class="m-0 inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                                            [class]="brief.kind === 'Screening'
                                                ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200'
                                                : 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200'">
                                            {{ brief.kind }}</p>
                                        }
                                    </div>
                                    @if (groupUsageBriefs(group).length > 0) {
                                    <div class="mt-1 flex flex-col gap-y-0.5">
                                        @for (brief of groupUsageBriefs(group); track brief.briefId) {
                                        <p class="m-0 truncate text-xs/5 text-gray-400 dark:text-gray-500">
                                            &#8627; {{ brief.kind }}: "{{ brief.briefTitle }}"</p>
                                        }
                                    </div>
                                    } @else {
                                    <p class="mt-1 m-0 text-xs/5 text-gray-400 dark:text-gray-500">— not attached</p>
                                    }
                                </div>
                            </div>
                            <div
                                class="hidden shrink-0 sm:flex sm:flex-col sm:items-end h-full items-center justify-center">
                                <button type="button" class="btn-fab-secondary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path d="m9 18 6-6-6-6" />
                                    </svg>
                                </button>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
                }
                @else {
                <div class="flex-1 flex flex-col items-center justify-center overflow-hidden">
                    <div class="text-center">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                            class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                            <path
                                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No groups</h3>
                        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by creating a new group.
                        </p>
                        <div class="mt-6">

                            <button (click)="showCreateGroupModal.set(true)" type="button"
                                class="inline-flex items-center gap-x-1.5 primary-button">
                                Add Group
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M12 5v14" />
                                    <path d="M5 12h14" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                }

                <!-- Main Content - END-->
            </article>

            <!-- Selected Group -->
            @if (selectedGroup()) {
            <article
                class="col-span-2 h-full flex flex-col card-container-pale-no-padding divide-y divide-zinc-200 dark:divide-zinc-600 overflow-hidden">
                <!-- Header -->
                <div class="shrink-0 px-2 py-2 drawer-header-primary">
                    <div class="flex space-x-3 h-full items-center justify-between">
                        <div class="min-w-0 flex-1 px-2">
                            <p class="text-md font-semibold text-primary">
                                {{ selectedGroup()?.groupName }}
                            </p>
                            <p class="text-sm text-secondary">
                                {{ groupVisibleDescription(selectedGroup()) }}
                            </p>
                            @if (selectedGroup()?.approvalStatus === 'approved' && groupApprovedByName(selectedGroup())) {
                            <p class="text-xs font-medium text-secondary">
                                Approved by {{ groupApprovedByName(selectedGroup()) }}
                            </p>
                            }
                        </div>

                        <div class="flex flex-row flex-wrap items-center justify-end gap-2">
                            <div #inviteSelectedTarget class="relative overflow-visible">
                                <button type="button" (click)="openInviteSelectedCreators($event)"
                                    class="btn-fab-secondary inline-flex items-center !px-4 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-60"
                                    [class.collaborators-fab--attention]="inviteTargetAttention()"
                                    aria-label="Invite selected creators to a brief"
                                    [disabled]="collaboratorsService.selectedCreators().length === 0">
                                    Invite Selected ({{ collaboratorsService.selectedCreators().length }})
                                </button>
                            </div>
                            <button type="button" (click)="openShareGroup($event)"
                                class="btn-fab-secondary inline-flex items-center gap-x-1.5 !px-4 text-sm font-medium"
                                aria-label="Share for review">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                    <polyline points="16 6 12 2 8 6" />
                                    <line x1="12" x2="12" y1="2" y2="15" />
                                </svg>
                                Share for review
                            </button>
                            <button (click)="openEditGroup($event)" class="btn-fab-secondary !px-3"
                                appTooltip="Edit Group" position="left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-pencil">
                                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                                    <path d="m15 5 4 4" />
                                </svg>
                            </button>
                            <button (click)="deleteGroup($event, selectedGroup()!)" class="btn-fab-delete"
                                appTooltip="Delete Group" position="left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-trash2-icon lucide-trash-2">
                                    <path d="M10 11v6" />
                                    <path d="M14 11v6" />
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                    <path d="M3 6h18" />
                                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Header - END -->

                <!-- List of Creators -->
                <div class="flex-1 flex flex-col items-center overflow-hidden">
                    @if (selectedGroupCreators() && selectedGroupCreators()!.length > 0) {
                    <div class="shrink-0 flex flex-wrap gap-2 w-full px-4 py-2" role="group"
                        aria-label="Filter creators by review">
                        @for (tab of reviewFilterTabs(); track tab.id) {
                        <button type="button" [attr.aria-pressed]="isReviewFilterSelected(tab.id)"
                            (click)="setReviewFilter(tab.id)" [class]="reviewFilterButtonClass(tab.id)">
                            {{ tab.label }}
                            <span class="tabular-nums">{{ tab.count }}</span>
                        </button>
                        }
                    </div>
                    @if (filteredSelectedGroupCreators().length > 0) {
                    <div
                        class="h-full w-full grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 overflow-y-auto scrollbar-transparent p-2">
                        @for (creator of filteredSelectedGroupCreators(); track creator.blazeFirebaseUid) {
                        <cmg-grou-creator-card [creator]="creator"
                            [navCreators]="filteredSelectedGroupCreators()"
                            [declined]="isDeclined(creator)"
                            [approved]="isApproved(creator)" [invited]="isInvited(creator)"
                            [reviewLabel]="reviewLabel(creator)"
                            [reviewNote]="creatorNote(creator)"
                            (remove)="removeCreatorFromGroup(creator)"></cmg-grou-creator-card>
                        }
                    </div>
                    } @else {
                    <div class="flex-1 flex flex-col items-center justify-center overflow-hidden">
                        <div class="text-center">
                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">
                                {{ emptyFilterCopy().title }}</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ emptyFilterCopy().message }}</p>
                        </div>
                    </div>
                    }

                    } @else if (selectedGroupCreators() && selectedGroupCreators()!.length == 0) {
                    <div class="flex-1 flex flex-col items-center justify-center overflow-hidden">
                        <div class="text-center">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                                class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                <path
                                    d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                    stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No Creators</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">There are no creators in this
                                group.
                            </p>
                            <button routerLink="/creators-v4-filter" type="button"
                                class="mt-4 inline-flex items-center gap-x-1.5 primary-button">
                                Search for Creators
                            </button>
                        </div>
                    </div>
                    } @else {
                    <div class="flex-1 flex flex-col items-center justify-center overflow-hidden">
                        <div class="text-center">
                            <svg aria-hidden="true"
                                class="mx-auto w-16 h-16 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading Group</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Finding creators in this group...
                            </p>
                        </div>
                    </div>
                    }
                </div>
                <!-- List of Creators - END -->
            </article>
            }
            <!-- Selected Group - END -->
            @else {
            <article
                class="col-span-2 h-full flex flex-col card-container-pale-no-padding overflow-hidden">
                @if (groupList().length === 0) {
                <div class="flex-1 h-full w-full flex flex-col items-center justify-center overflow-y-auto p-6">
                    <div class="w-full max-w-3xl flex flex-col items-center text-center">
                        <div
                            class="size-16 rounded-xl bg-primary/10 text-accent flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8" aria-hidden="true">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                        </div>
                        <h2 class="mt-4 text-lg font-semibold text-primary">Keep your favourite creators in groups</h2>
                        <p class="mt-1 text-sm text-secondary max-w-md">Create a group, add creators from their
                            profiles, then send the shortlist to your team for approval.</p>

                        <ol class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 w-full text-left">
                            <li class="flex flex-col gap-3 rounded-lg border border-primary/15 bg-primary/10 p-4 dark:border-primary/20 dark:bg-primary/15">
                                <div
                                    class="size-12 rounded-md bg-pink-500/10 text-pink-400 border border-pink-400 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="M12 10v6" />
                                        <path d="M9 13h6" />
                                        <path
                                            d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                    </svg>
                                </div>
                                <div>
                                    <p class="m-0 text-xs font-medium text-secondary">Step 1</p>
                                    <h3 class="mt-1 text-sm font-semibold text-primary">Create a group</h3>
                                    <p class="mt-1 text-sm text-secondary">Name it after a campaign, niche, or
                                        shortlist so you can find it later.</p>
                                </div>
                            </li>
                            <li class="flex flex-col gap-3 rounded-lg border border-primary/15 bg-primary/10 p-4 dark:border-primary/20 dark:bg-primary/15">
                                <div
                                    class="size-12 rounded-md bg-primary/10 text-accent border border-primary flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M19 8v6" />
                                        <path d="M22 11h-6" />
                                    </svg>
                                </div>
                                <div>
                                    <p class="m-0 text-xs font-medium text-secondary">Step 2</p>
                                    <h3 class="mt-1 text-sm font-semibold text-primary">Add creators</h3>
                                    <p class="mt-1 text-sm text-secondary">Open a creator's profile from Creators and
                                        click Add to Group.</p>
                                </div>
                            </li>
                            <li class="flex flex-col gap-3 rounded-lg border border-primary/15 bg-primary/10 p-4 dark:border-primary/20 dark:bg-primary/15">
                                <div
                                    class="size-12 rounded-md bg-yellow-500/10 text-yellow-500 border border-yellow-500 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                        <polyline points="16 6 12 2 8 6" />
                                        <line x1="12" x2="12" y1="2" y2="15" />
                                    </svg>
                                </div>
                                <div>
                                    <p class="m-0 text-xs font-medium text-secondary">Step 3</p>
                                    <h3 class="mt-1 text-sm font-semibold text-primary">Send to your team</h3>
                                    <p class="mt-1 text-sm text-secondary">Share a link or email a colleague so they can
                                        review the shortlist before you invite.</p>
                                </div>
                            </li>
                        </ol>

                        <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
                            <button (click)="showCreateGroupModal.set(true)" type="button"
                                class="inline-flex items-center gap-x-1.5 primary-button">
                                Add Group
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M12 5v14" />
                                    <path d="M5 12h14" />
                                </svg>
                            </button>
                            <button routerLink="/creators-v4-filter" type="button"
                                class="inline-flex items-center gap-x-1.5 secondary-button text-secondary">
                                Browse Creators
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                } @else if (groupList().length) {
                <div class="flex-1 h-full w-full flex flex-col items-center justify-center overflow-hidden p-6">
                    <div class="text-center max-w-sm">
                        <div
                            class="mx-auto size-16 rounded-xl bg-primary/10 text-accent flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8" aria-hidden="true">
                                <path
                                    d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                            </svg>
                        </div>
                        <h2 class="mt-4 text-lg font-semibold text-primary">Select a group</h2>
                        <p class="mt-1 text-sm text-secondary">Choose a group from the list to see its creators.</p>
                    </div>
                </div>
                }
            </article>
            }


        </div>
    </div>
</div>

@if (whatsNewService.isOpen()) {
<cmg-groups-whats-new (close)="whatsNewService.close()"></cmg-groups-whats-new>
}

@if (showCreateGroupModal()) {
<cmg-create-group (close)="closeCreateGroup($event)"></cmg-create-group>
}

@if (showEditGroupModal() && selectedGroup()) {
<cmg-edit-group [groupToEdit]="selectedGroup()!" (close)="closeEditGroup($event)"></cmg-edit-group>
}

@if (showShareGroupModal() && selectedGroup()) {
<cmg-share-group [group]="selectedGroup()!" (close)="closeShareGroup($event)"></cmg-share-group>
}

@if (collaboratorsService.showCollaborators()) {
<cc-collaborators></cc-collaborators>
}

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}

@if (deleteGroupState() === 'deleting') {
<atom-deleting-overlay></atom-deleting-overlay>
}